import { queryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { PutAdminV1OrgProductsIdRelationsBody } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

export function productRelationsQueryOptions(productId: string) {
  return queryOptions({
    queryKey: productKeys.relations(productId),
    queryFn: () => productsApi.getRelations(productId),
  });
}

export function useProductRelations(productId: string) {
  return useQuery(productRelationsQueryOptions(productId));
}

/** PUT replaces every relation of the product; order within a type is display order. */
export function useSetProductRelations(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PutAdminV1OrgProductsIdRelationsBody) =>
      productsApi.setRelations(productId, body),
    onSuccess: (items) => {
      queryClient.setQueryData(productKeys.relations(productId), items);
    },
  });
}
